<template>
  <div  id="chat-wrapper">
    <div class="chat-block-broker">
      
      <div class="chat-broker-header">
        <div
          class="header-chat-broker"
        >
          <div class="back-button-wrapper pointer" @click="closePopup">
            <app-icon name="close" :size="24" />
          </div>
          <client-chat-share-handler :client-object="getClientShareInfo()"/>
        </div>
        <div class="client-name-block">
          <img
            src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png"
            loading="lazy"
            alt=""
            class="image-10"
          />
          <div class="div-block-28">
            <user-manager-handler :rules="['single']" :client-info="client" client clients/>
          </div>
        </div>
      </div>
      
      <div
        class="chat-panel-broker broker flex-column-reverse"
        v-if="clientChatInitialized"
        ref="chat-window"
        @scroll="checkForNextPage"
      >
        <div
          v-for="(message, key) in messages"
          :class="[
            message.sender === client.id
              ? 'question-broker-chat'
              : 'question-block-broker',
          ]"
          :key="key"
        >
          <div
            :class="[
              message.sender === client.id
                ? 'message-answer'
                : 'message-question',
            ]"
          >
            <div
              :class="[
                message.sender === client.id
                  ? 'text-message-left'
                  : 'text-message-right-2',
              ]"
              v-if="isUrl(message.content)"
            >
              {{ message.content }}
            </div>
            <div class="text-message-right-2" v-html="urlify(message.content)" v-else></div>
            <div class="file-to-download" v-if="message.attachment">
              <a
                :class="[
                  message.sender === client.id ? 'white--text' : 'bl-color',
                ]"
                style="text-decoration: none"
                class="download-link-2"
                target="_blank"
                :href="message.attachment"
                :download="message.attachment_filename"
              >{{ message.attachment_filename }}</a
              >
              <svg
                v-if="message.sender !== client.id"
                width="25"
                height="25"
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.2808 11.667H3.92889C3.75039 11.667 3.60514 11.5363 3.60514 11.3753V2.62533C3.60514 2.46433 3.75039 2.33366 3.92889 2.33366H6.52181V4.75449C6.52181 5.67149 7.23173 6.41699 8.10498 6.41699H10.6051V11.3753C10.6051 11.5363 10.4593 11.667 10.2808 11.667ZM10.4004 5.25033H8.10498C7.87514 5.25033 7.68848 5.02808 7.68848 4.75449V2.33366H7.75381L10.4004 5.25033ZM11.6201 4.85833L8.44448 1.35833C8.33423 1.23641 8.17731 1.16699 8.01223 1.16699H3.92889C3.10698 1.16699 2.43848 1.82149 2.43848 2.62533V11.3753C2.43848 12.1792 3.10698 12.8337 3.92889 12.8337H10.2808C11.1027 12.8337 11.7718 12.1792 11.7718 11.3753V5.25033C11.7718 5.10508 11.7176 4.96566 11.6201 4.85833Z"
                  fill="$primary"
                />
                <mask
                  id="mask0_1400_480"
                  style="mask-type: alpha"
                  maskUnits="userSpaceOnUse"
                  x="2"
                  y="1"
                  width="10"
                  height="12"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.2808 11.667H3.92889C3.75039 11.667 3.60514 11.5363 3.60514 11.3753V2.62533C3.60514 2.46433 3.75039 2.33366 3.92889 2.33366H6.52181V4.75449C6.52181 5.67149 7.23173 6.41699 8.10498 6.41699H10.6051V11.3753C10.6051 11.5363 10.4593 11.667 10.2808 11.667ZM10.4004 5.25033H8.10498C7.87514 5.25033 7.68848 5.02808 7.68848 4.75449V2.33366H7.75381L10.4004 5.25033ZM11.6201 4.85833L8.44448 1.35833C8.33423 1.23641 8.17731 1.16699 8.01223 1.16699H3.92889C3.10698 1.16699 2.43848 1.82149 2.43848 2.62533V11.3753C2.43848 12.1792 3.10698 12.8337 3.92889 12.8337H10.2808C11.1027 12.8337 11.7718 12.1792 11.7718 11.3753V5.25033C11.7718 5.10508 11.7176 4.96566 11.6201 4.85833Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_1400_480)">
                  <rect x="0.104492" width="14" height="14" fill="#0019D9"/>
                </g>
              </svg>
              <svg
                v-else
                width="25"
                height="25"
                viewBox="0 0 15 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.2808 11.667H3.92889C3.75039 11.667 3.60514 11.5363 3.60514 11.3753V2.62533C3.60514 2.46433 3.75039 2.33366 3.92889 2.33366H6.52181V4.75449C6.52181 5.67149 7.23173 6.41699 8.10498 6.41699H10.6051V11.3753C10.6051 11.5363 10.4593 11.667 10.2808 11.667ZM10.4004 5.25033H8.10498C7.87514 5.25033 7.68848 5.02808 7.68848 4.75449V2.33366H7.75381L10.4004 5.25033ZM11.6201 4.85833L8.44448 1.35833C8.33423 1.23641 8.17731 1.16699 8.01223 1.16699H3.92889C3.10698 1.16699 2.43848 1.82149 2.43848 2.62533V11.3753C2.43848 12.1792 3.10698 12.8337 3.92889 12.8337H10.2808C11.1027 12.8337 11.7718 12.1792 11.7718 11.3753V5.25033C11.7718 5.10508 11.7176 4.96566 11.6201 4.85833Z"
                  fill="#0019D9"
                />
                <mask
                  id="mask0_1400_480"
                  style="mask-type: alpha"
                  maskUnits="userSpaceOnUse"
                  x="2"
                  y="1"
                  width="10"
                  height="12"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.2808 11.667H3.92889C3.75039 11.667 3.60514 11.5363 3.60514 11.3753V2.62533C3.60514 2.46433 3.75039 2.33366 3.92889 2.33366H6.52181V4.75449C6.52181 5.67149 7.23173 6.41699 8.10498 6.41699H10.6051V11.3753C10.6051 11.5363 10.4593 11.667 10.2808 11.667ZM10.4004 5.25033H8.10498C7.87514 5.25033 7.68848 5.02808 7.68848 4.75449V2.33366H7.75381L10.4004 5.25033ZM11.6201 4.85833L8.44448 1.35833C8.33423 1.23641 8.17731 1.16699 8.01223 1.16699H3.92889C3.10698 1.16699 2.43848 1.82149 2.43848 2.62533V11.3753C2.43848 12.1792 3.10698 12.8337 3.92889 12.8337H10.2808C11.1027 12.8337 11.7718 12.1792 11.7718 11.3753V5.25033C11.7718 5.10508 11.7176 4.96566 11.6201 4.85833Z"
                    fill="white"
                  />
                </mask>
                <g mask="url(#mask0_1400_480)">
                  <rect x="0.104492" width="14" height="14" fill="#fff"/>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center" style="height: 100%" v-else>
        <v-progress-circular
          class="loading-spinner"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-if="fileName" class="filename">
        <div class="pop-300 white--text">
          <img class="pb-1" src="@/images/CloudChat.svg" alt=""/>
          <span class="pl-2">
            {{ fileName }}
          </span>
        </div>
        <div class="red--text pop-400 pointer" @click="removeFile()">
          <img src="@/images/RemoveFileChat.svg" alt=""/>
        </div>
      </div>
      <div class="chat-input-grid">
        <div class="form-block w-form">
          <form name="chat-message" @submit.prevent>
            <input
              :class="{ 'message-is-missing': messageMissing }"
              @click="setSeen"
              @keydown.enter="sendMessage"
              class="message-text-2 w-input"
              maxlength="256"
              type="text"
              placeholder="Napíšte odpoveď .."
              v-model="messageValue"
            />
            <input type="submit" id="submit-form" class="d-none"/>
          </form>
        </div>
        <div class="chat-ctas">
          <quick-response-chat-handler/>
          <div class="image-upload-btn">
            <label for="file-upload" style="margin-bottom: 0 !important;">
              <img
                src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1e_icons8-upload-to-the-cloud.svg"
                class="nav-link-icon small filter-primary"
              >
            </label>
            <input @change="handleFiles" id="file-upload" type="file"/>
          </div>
          <span class="send-button pointer" @click="sendMessage">
            <img class="nav-link-icon small white" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f2c_icons8-sent.svg">
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  sendMessage,
  getMessages,
  setMessageSeen,
} from "@/services/brokerService";
import { patchClientProfile } from "@/services/brokerService";
import BrokerPickerHandler from "../../shared/PopupHandler/Popups/BrokerPicker/BrokerPickerHandler";
import MortgagePickerHandler from "../../shared/PopupHandler/Popups/MortgagePicker/MortgagePickerHandler";
import UserManagerHandler from "../../shared/PopupHandler/Popups/UserManager/UserManagerHandler";
import imagesConvert from "../../../mixins/imagesConvert";
import QuickResponseChatHandler from "../../shared/PopupHandler/Popups/QuickResponseChat/QuickResponseChatHandler";
import ClientChatShareHandler from "../../shared/PopupHandler/Popups/ClientChatShare/ClientChatShareHandler.vue";
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "ChatContent",
  props: {
    client: Object,
    quickMessage: [String, null],
  },
  components: {
    AppIcon,
    ClientChatShareHandler,
    QuickResponseChatHandler,
    UserManagerHandler,
    MortgagePickerHandler,
    BrokerPickerHandler,
  },
  watch: {
    quickMessage (newMessage) {
      if (!newMessage) return;
      this.messageValue = newMessage;
      this.$emit("quickMessageSet");
    },
  },
  mixins: [
    imagesConvert,
  ],
  data: () => ({
    chatConfig: {
      page: 1,
      page_size: 50
    },
    messagesCount: 0,
    urlRegex: /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi,
    clientChatInitialized: false,
    messageMissing: false,
    file: "",
    fileName: "",
    unseenIds: [],
    messages: [],
    messageValue: "",
    chatinterval: null,
    loadingNextPage: false,
  }),
  methods: {
    checkForNextPage() {
      const container = this.$refs["chat-window"];
      const nearBottom = (container.scrollTop * -1) + container.clientHeight >= container.scrollHeight - 10;
      if (!this.loadingNextPage && nearBottom) {
        this.fetchNexMessagePage();
      }
    },
    async fetchNexMessagePage() {
      if (this.messagesCount > this.messages.length) {
        this.loadingNextPage = true;
        this.chatConfig.page += 1;
        const messages = await this.getMessagesAndSetCount(this.chatConfig);
        for (const message of messages) {
          if (this.isNewMessage(message)) {
            this.messages.push(message);
          }
        }
        this.loadingNextPage = false;
      }
    },
    getClientShareInfo() {
      return {
        label: `${this.client.first_name} ${this.client.last_name}`,
        id: this.client.id,
      }
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    isUrl (message) {
      const urlifed = message.replace(this.urlRegex, (url) => {
        return '<a href="' + url + '">' + url + "</a>";
      });
      return urlifed === message;
    },
    urlify (message) {
      return message.replace(this.urlRegex, (url) => {
        return (
          '<a class="messageURL" href="' + url + '" target="_blank" style="color: white; word-wrap: break-word">' + url + '</a>'
        )
      });
    },
    handleFiles () {
      const file = document.getElementById("file-upload").files[0];
      this.fileName = file.name;
      this.getBase64(file);
    },
    removeFile () {
      this.file = "";
      this.fileName = "";
    },
    getBase64 (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = () => {
        this.file = reader.result;
      };
    },
    setSeen () {
      if (this.unseenIds.length > 0) {
        this.unseenIds.forEach((id) => {
          setMessageSeen(id);
        });
        this.unseenIds = [];
      }
    },
    async setMessages () {
      const messages = await this.getMessagesAndSetCount(this.chatConfig);
      for (const message of messages) {
        if (message.seen_at === null && message.sender === this.client.id) {
          this.unseenIds.push(message.id);
        }
      }
      this.clientChatInitialized = true;
      this.messages = messages;
    },
    async appendNewMessages() {
      const messages = await this.getMessagesAndSetCount({...this.chatConfig, page: 1});
      for (const message of messages) {
        if (this.isNewMessage(message)) {
          this.messages.unshift(message);
          this.unseenIds.push(message.id);
        }
      }
    },
    async getMessagesAndSetCount(config) {
      const messagesObject = (await getMessages(this.client.id, config));
      this.messagesCount = messagesObject.count;
      return messagesObject.results;
    },
    async initializeChat() {
      await this.setMessages();
      this.setSeen();
      this.chatinterval = setInterval(this.appendNewMessages, 10000);
    },
    setFinancnik () {
      const role = this.$store.getters["userState/getRole"];
      if (role === "alex_admin") return;
      if (!this.client.financnik) {
        patchClientProfile(
          {financnik: this.$store.getters["userState/getId"]},
          this.client.client_profile.id
        );
      }
    },
    sendFile () {
      if (this.fileName !== "" && this.file !== "") {
        this.messageValue = "súbor";
        this.fileName = this.fileName.replace(/\s/g, "");
        sendMessage(
          this.client.id,
          this.messageValue,
          this.file,
          this.fileName
        ).then((res) => {
          this.messages.unshift(res);
        });
        this.messageMissing = false;
        this.messageValue = "";
        this.file = "";
        this.fileName = "";
      } else {
        this.messageMissing = true;
      }
    },
    isNewMessage(message) {
      return !this.messages.find((m) => m.id === message.id);
    },
    sendTextMessage () {
      if (this.messageValue !== "") {
        if (this.fileName !== "" && this.file !== "") {
          sendMessage(
            this.client.id,
            this.messageValue,
            this.file,
            this.fileName
          ).then((res) => {
            this.messages.unshift(res);
          });
        } else {
          sendMessage(this.client.id, this.messageValue, null, null).then(
            (res) => {
              this.messages.unshift(res);
            }
          );
        }
        this.messageValue = "";
        this.file = "";
        this.fileName = "";
        this.messageMissing = false;
      } else {
        this.sendFile();
      }
    },
    sendMessage() {
      this.setFinancnik();
      this.sendTextMessage();
    },
  },
  mounted () {
    const int = setInterval(() => {
      const loading = this.$store.getters["appState/getLoadingMainData"];
      if (!loading) {
        this.initializeChat();
        clearInterval(int);
      }
    }, 50);
  },
  beforeDestroy () {
    clearInterval(this.chatinterval);
  },
};
</script>

<style scoped lang="scss">

#chat-wrapper,
.chat-block-broker {
  background: var(--app-bg);
  color: var(--app-text);
}

.chat-broker-header {
  border-bottom: 1px solid var(--app-border);
  background: var(--app-surface);
  color: var(--app-text);
  box-shadow: var(--app-shadow);
}

.chat-broker-header .client-name-block {
  border: 1px solid var(--app-border);
  background: var(--app-surface-muted);
  color: var(--app-text);
  box-shadow: none;
}

.chat-panel-broker {
  gap: 8px;
  background: var(--app-bg);
}

.question-block-broker,
.question-broker-chat {
  display: flex;
  width: min(82%, 620px);
}

.question-block-broker {
  align-self: flex-end;
  justify-content: flex-end;
}

.question-broker-chat {
  align-self: flex-start;
}

.text-message-right-2,
.text-message-left {
  margin: 0;
  padding: 14px 16px;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  color: var(--app-text);
  font-weight: 500;
  line-height: 1.5;
  box-shadow: var(--app-shadow);
}

.question-block-broker .text-message-right-2,
.question-block-broker .text-message-left {
  border-color: var(--app-primary);
  background: var(--app-primary);
  color: #ffffff;
}

.question-broker-chat .text-message-right-2,
.question-broker-chat .text-message-left {
  background: var(--app-surface-muted);
  color: var(--app-text);
}

.chat-input-grid {
  border-top: 1px solid var(--app-border);
  background: var(--app-surface);
}

.message-text-2 {
  min-height: 42px;
  padding: 0 14px;
  border: 1px solid var(--app-border);
  border-radius: 10px;
  background: var(--app-surface-muted);
  color: var(--app-text);
}

.message-text-2::placeholder {
  color: var(--app-text-muted);
}

.popup .popup-form {
  width: 85% !important;
}

</style>
